import { z } from 'zod';
/** Запрос визуализации XML ЭДО в PDF: имя файла + сам XML. */
export const pdfVizSchema = z.object({
    fileName: z.string().min(1).max(300),
    xml: z.string().min(1).max(4_000_000),
});
//# sourceMappingURL=pdf-viz.js.map